/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LookupUtxoParams,
  UtxoResponse
} from '../model';

import { arbBotFetcher } from '../../../lib/api/fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getLookupUtxoUrl = (params: LookupUtxoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/utxos?${stringifiedParams}` : `/api/utxos`
}

export const lookupUtxo = async (params: LookupUtxoParams, options?: Parameters<typeof arbBotFetcher>[1]): Promise<UtxoResponse> => {

  return arbBotFetcher<UtxoResponse>(getLookupUtxoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLookupUtxoQueryKey = (params?: LookupUtxoParams,) => {
    return [
    `/api/utxos`, ...(params ? [params] : [])
    ] as const;
    }


export const getLookupUtxoQueryOptions = <TData = Awaited<ReturnType<typeof lookupUtxo>>, TError = void>(params: LookupUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupUtxo>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLookupUtxoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupUtxo>>> = ({ signal }) => lookupUtxo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lookupUtxo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LookupUtxoQueryResult = NonNullable<Awaited<ReturnType<typeof lookupUtxo>>>
export type LookupUtxoQueryError = void


export function useLookupUtxo<TData = Awaited<ReturnType<typeof lookupUtxo>>, TError = void>(
 params: LookupUtxoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupUtxo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupUtxo>>,
          TError,
          Awaited<ReturnType<typeof lookupUtxo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupUtxo<TData = Awaited<ReturnType<typeof lookupUtxo>>, TError = void>(
 params: LookupUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupUtxo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupUtxo>>,
          TError,
          Awaited<ReturnType<typeof lookupUtxo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupUtxo<TData = Awaited<ReturnType<typeof lookupUtxo>>, TError = void>(
 params: LookupUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupUtxo>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLookupUtxo<TData = Awaited<ReturnType<typeof lookupUtxo>>, TError = void>(
 params: LookupUtxoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupUtxo>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLookupUtxoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






